export const Labels = {
  common: {
    back: 'Назад',
    close: 'Закрыть',
    delete: 'Удалить',
    save: 'Сохранить',
    loading: 'Загрузка...',
    yes: 'Да',
    no: 'Нет',
    start: 'Начать',
    show: 'Показать',
    error: 'Ошибка',
  },
  onboardingTour: {
    skip: 'Пропустить',
    next: 'Далее',
    done: 'Готово',
  },
  feed: {
    catalogTab: 'Каталог',
    stylistsTab: 'Стилисты',
  },
  navigation: {
    outfits: 'образы',
    search: 'лента',
    wardrobe: 'шкаф',
    profile: 'профиль',
    generate: 'генерация',
    chat: 'чат',
  },
  wardrobe: {
    noUploadedItems: 'Нет загруженных вещей',
    noSavedOutfits: 'Нет сохранённых образов',
    saveOutfitHint: 'Сохраняйте понравившиеся образы, нажимая ♡ при генерации',
    noFavoriteItems: 'Нет избранных вещей',
    saveFavoriteItemHint: 'Добавляйте вещи в избранное, нажимая ♡',

    categories: {
      outerwear: 'Верхняя одежда',
      tops: 'Верх',
      bottoms: 'Низ',
      dresses: 'Платья',
      shoes: 'Обувь',
      bags: 'Сумки',
      accessories: 'Аксессуары',
    },

    uploadPhotoPage: {
      enhance: 'Улучшить фото',
      getOutfit: 'Получить образ',
      uploadedAlt: 'Загруженное фото',
      uploadPlaceholder: 'Загрузить фото',
      selectCategoryPlaceholder: 'Выберите категорию',
    },

    product: {
      savedToWardrobe: 'Сохранено в шкаф',
      priceNotification: 'Следить за ценой',
      addFavorite: 'Вещь добавлена в избранное',
      removeFavorite: 'Вещь удалена из избранного',
    },

    gallery: {
      noOutfits: 'Нет образов для отображения',
    },

    tabs: {
      favoriteItems: 'Избранные вещи',
      myItems: 'Мой шкаф',
      favoriteOutfits: 'Избранные образы',
    },

    uploadError: 'Не удалось загрузить фото. Попробуйте еще раз.',
    backgroundRemoval: 'Идет удаление фона...',
    uncategorized: 'Без категории',

    uploadModal: {
      correctPhoto: 'Правильный способ фотографирования',
      wrongPhoto: 'Неправильный способ фотографирования',
    },

    myItemsListTour: {
      stepTabsTitle: 'Вкладки',
      stepTabsDescription:
        'Переключайся между избранным, своим шкафом и сохранёнными образами',
      stepCategoriesTitle: 'По полочкам',
      stepCategoriesDescription:
        'Вещи сгруппированы по категориям — удобно смотреть',
      stepItemTitle: 'Карточка вещи',
      stepItemDescription: 'Нажми на вещь, чтобы открыть и отредактировать',
      stepDeleteTitle: 'Убрать из шкафа',
      stepDeleteDescription: 'Удали вещь из шкафа, если она больше не нужна',
      stepFabTitle: 'Новая вещь',
      stepFabDescription: 'Нажми «+», чтобы добавить фото вещи в шкаф',
      stepChatFromWardrobeTitle: 'Образ с твоей вещью',
      stepChatFromWardrobeDescription:
        'Перейди в чат, нажми + и получи образ с твоей вещью',
    },

    deleteModal: {
      confirmQuestion: 'Вы действительно хотите удалить эту вещь?',
      confirmQuestionOutfit: 'Удалить образ?',
    },

    review: {
      title: 'Обзор вещей',
      deleteConfirm: 'Вы уверены, что хотите удалить эту вещь?',
      deleteError: 'Не удалось удалить вещь. Попробуйте еще раз.',
      saveError: 'Не удалось сохранить изменения. Попробуйте еще раз.',
    },

    addItem: {
      sheetTitle: 'Добавить вещь',
      takePhoto: 'Сфотографировать',
      fromGallery: 'Выбрать из галереи',
      onboardingModalTitle: 'Загрузи свои вещи',
      onboardingModalDescription:
        'Сделай фото на белом фоне без посторонних предметов',
      onboardingModalAction: 'Понятно',
      onboardingGoodCaption: 'Правильно',
      onboardingBadCaption: 'Неправильно',
      uploading: 'Вещь загружается…',
      recognitionFailed: 'Упс, не удалось распознать вещь',
      improve: 'Улучшить',
      repeat: 'Повторить',
      revertImage: 'Вернуть фото до улучшения',
      addButton: 'Добавить',
      successTitle: 'Успех!',
      successSubtitle: 'Ваши вещи добавлены в шкаф',
      selectCategory: 'Категория',
      validationTooMany: 'Можно выбрать не больше 5 фотографий',
      validationSize: 'Файл слишком большой (макс. 5 МБ)',
      validationType: 'Допустимы только PNG и JPEG',
      leaveWhileUploadingMessage:
        'Вы действительно хотите выйти? Загруженные вещи не сохранятся',
      cameraShutter: 'Снять',
      cameraClose: 'Закрыть',
      cameraPermissionDenied:
        'Нет доступа к камере. Разрешите использование в настройках браузера.',
      cameraNotAvailable:
        'Не удалось открыть камеру. Попробуйте снова или выберите фото из галереи.',
      tour: {
        stepPreviewTitle: 'Превью',
        stepPreviewDescription:
          'Нажми на фото, чтобы открыть его в полном размере',
        stepCategoryTitle: 'Выбери сам',
        stepCategoryDescription:
          'Уточни категорию вещи — так проще искать её в шкафу',
        stepDeleteTitle: 'Удалить',
        stepDeleteDescription:
          'Можно убрать вещь из списка до добавления в шкаф',
        stepFooterTitle: 'В шкаф',
        stepFooterDescription:
          'Когда всё готово, нажми сюда — вещи попадут в твой шкаф',
      },
    },

    edit: {
      notFound: 'Вещь не найдена',
      imageAlt: 'Вещь',
      categoryLabel: 'Категория',
      categoryNotSelected: 'Не выбрано',
    },
  },
  filters: {
    titles: {
      palette: 'Цветовая палитра',
      price: 'Стоимость образа',
      style: 'Стиль',
      clothingSize: 'Размер одежды (RU)',
      shoeSize: 'Размер обуви',
      specialWishes: 'Особые пожелания',
      season: 'Сезон',
      gender: 'Пол',
      brands: 'Бренды',
    },
    price: {
      upTo: 'до',
    },
    sizes: {
      noSize: 'без размера',
    },
    specialWishes: {
      closedArms: 'Закрыть руки',
      closedLegs: 'Закрыть ноги',
      closedShoulders: 'Закрыть плечи',
      noDeepNeckline: 'Без глубокого декольте',
      noHeels: 'Без каблуков',

      figureFit: 'По фигуре',
      oversized: 'Оверсайз',
      noBright: 'Без светлого',
      noBrightColors: 'Без яркого',
      noBlack: 'Без чёрного',
      print: 'Принт',
      naturalFabrics: 'Только натуральные ткани',
      asymmetric: 'Ассиметричные детали',
    },
    seasons: {
      autumn: 'Осень',
      winter: 'Зима',
      spring: 'Весна',
      summer: 'Лето',
    },
    gender: {
      male: 'Мужской',
      female: 'Женский',
    },
    onSaleOnly: 'Только со скидкой',
    madeInMoscow: 'Сделано в Москве',
  },
  profile: {
    yourSubscription: 'Ваша подписка',
    planExpiresAt: 'Действует до',
    daysWithUs: 'С нами уже',
    daysWithUsSuffix: 'дн.',
    uploadsPerMonth: 'Загрузок в месяц',
    itemsInWardrobe: 'Вещей в гардеробе',
    outfitsGenerations: 'Генераций образов в месяц',
    limitUsages: 'Обновите план в профиле, чтобы получить больше примерок',
    tryOnLimitTitle: 'Превышен лимит примерок',
    tryOnLimitSubscribedMessage: 'Обновите подписку',
    tryOnLimitFreeMessage: 'Следующий раз образ можно примерить через 24 часа',
    tryOnLimitSubscribedCta: 'Обновить',
    tryOnLimitFreeCta: 'Перейти на pro',
    wardrobeLimitTitle: 'Превышен лимит вещей в шкафу',
    wardrobeLimitFreeMessage: 'Оформите подписку и загрузите больше вещей',
    wardrobeLimitSubscribedMessage:
      'Обновите подписку и загрузите больше вещей',
    wardrobeLimitFreeCta: 'Перейти на pro',
    wardrobeLimitSubscribedCta: 'Обновить',
    enhanceLimitTitle: 'Превышен лимит улучшений',
    enhanceLimitFreeMessage: 'Оформите подписку и улучшайте больше вещей',
    enhanceLimitSubscribedMessage: 'Обновите подписку и улучшайте больше вещей',
    enhanceLimitFreeCta: 'Перейти на pro',
    enhanceLimitSubscribedCta: 'Обновить',
    deleteAccount: 'Сбросить аккаунт',
    deleteAccountTitle: 'Вы точно хотите удалить аккаунт?',
    deleteAccountConfirm:
      'Все ваши личные данные будут безвозвратно удалены. Это действие нельзя отменить.',
    cancelSubscription: 'Отменить подписку',
    cancelSubscriptionConfirm: 'Вы действительно хотите отменить подписку?',
  },
  subscription: {
    pageTitle: 'Подписка',
    youAreSubscribing: 'Вы подключаете',
    planNamePro: 'pro',
    pricePerMonth: (price: number) => `${price} ₽ / месяц`,
    subscribedPriceLine: (price: number) => `Стоимость — ${price} ₽ / месяц`,
    featureVirtualTryOns: (count: string) => `${count} виртуальных примерок`,
    featureWardrobeItems: (count: string) => `${count} вещей в шкафу`,
    featureEnhancePerMonth: (count: string) => `${count} улучшений фото`,
    featureChatRequests: (count: string) => `${count} запросы в ИИ чат`,
    unlimited: 'бесконечно',
    promoLabel: 'У вас есть промокод?',
    promoPlaceholder: 'Промокод',
    applyPromoAria: 'Применить промокод',
    promoNotAvailable: 'Промокоды пока недоступны',
    agree: 'Я согласен с',
    termsLink: 'условиями подписки',
    totalDue: 'Итого к оплате',
    totalWithCurrency: (price: number) => `${price} ₽`,
    connect: 'Подключить',
    pleaseWait: 'Подождите…',
    tryOnsLeftPrefix: 'Осталось виртуальных примерок —',
    wardrobeItemsLeftPrefix: 'Осталось вещей в шкафу —',
    enhanceLeftPrefix: 'Осталось улучшений фото —',
    nextPaymentLabel: 'Дата следующего платежа —',
    renewalCancelledUntil: (dateLabel: string) =>
      `Автопродление отключено. Доступ Pro до ${dateLabel}.`,
  },
} as const;
